import createIcon from '../../createIcon';

/**
 * @component @name PlaylistPlay
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA4LjVIMi41VjEwLjVIMTMuNVY4LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuNSA0LjVIMi41VjYuNUgxMy41VjQuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik05LjUgMTIuNUgyLjVWMTQuNUg5LjVWMTIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNS41IDExLjVWMTkuNUwyMS41IDE1LjVMMTUuNSAxMS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlaylistPlay = createIcon('PlaylistPlay', [
  ['path', { d: 'M13.5 8.5H2.5V10.5H13.5V8.5Z', key: '1v82i6' }],
  ['path', { d: 'M13.5 4.5H2.5V6.5H13.5V4.5Z', key: 'wp23p3' }],
  ['path', { d: 'M9.5 12.5H2.5V14.5H9.5V12.5Z', key: 'ugev44' }],
  ['path', { d: 'M15.5 11.5V19.5L21.5 15.5L15.5 11.5Z', key: '1cut0c' }],
]);

export default PlaylistPlay;
